import _ from 'lodash';
import optionsObject from '../defaults';
import constructOpts from '../js/constructOptions';

/**
 * Function that initializes our error-screen.
 *
 * @param {*} Vue Vue instance we are mounting the error screen to.
 * @param {*} opts Passed in options for the error screen.
 * @param {*} component Our PlaypositErrorScreen.vue component.
 */
export default function initializeErrorScreen(Vue, opts, component) {
  const options = { ...optionsObject.optionsDefaults, ...opts };
  const root = new Vue({
    data: options,
    render: (createElement) => createElement(component),
  });
  Vue.$playpositErrorScreen = root;
  root.enabled = false;
  Vue.prototype.$playpositErrorScreenEnabled = false;
  Vue.prototype.$enablePlaypositErrorScreen = (errorScreenOptions) => {
    errorScreenOptions = constructOpts(errorScreenOptions);
    optionsObject.option_fields.forEach((field) => {
      if(_.has(errorScreenOptions, `${field}`)) {
        root[field] = errorScreenOptions[field];
      }
    });
    if(typeof (root.buttons) === 'string') {
      root.buttons = root.buttons.split(',').map((action) => {
        const buttonAction = {
          action,
          order: null,
        };
        return buttonAction;
      });
    }
    root.buttons.forEach((b, idx) => {
      if (!_.isNumber(b.order)) b.order = idx;
    });
    root.enabled = true;
    Vue.prototype.$playpositErrorScreenEnabled = true;
  };
  Vue.prototype.$disablePlaypositErrorScreen = () => {
    root.enabled = false;
    Vue.prototype.$playpositErrorScreenEnabled = false;
  };
  root.$mount(document.body.appendChild(document.createElement('div')));
}